import createDocumentResource from 'src/actions/shared/createDocumentResource';
import emptyObserverCreator from '../shared/emptyObserverCreator';

export interface Organization {
  id: string;
  loginDomain?: string;
  name?: string;
  timezone: string;
  gladlyUrl: string;
}

const organizationResource = createDocumentResource<Organization>({
  name: 'organization',
  endpoint: 'v1/organizations/:orgId',
  observerCreator: emptyObserverCreator,
});

export default organizationResource;
